import React from "react";
import PropTypes from "prop-types";
import { Panel, Row, Col, Button } from "react-bootstrap";
import TableAsociados from "./components/TableAsociados";
import InputSelect from "../../components/input-select/InputSelect";
import ApiClient from "../../utils/ApiClient";
import UiUtils from "../../utils/UiUtils";
import lstrings from "../../utils/LStrings";
import "./TabAsociados.css";

class TabAsociados extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			user: "0",
			servicio: 0,
			dialogShow: false,
			selectedRow: null,
			searchButtonDisabled: true,
			mostrarPDF: false,
		};
	}

	/**
	 * Realizo la carga inicial de asociados e insitutos para autocompletar
	 */
	componentDidMount() {
		UiUtils.showProgress(true);
		ApiClient.getCentroDeudorAsociados()
			.then(this.onFinishGetListAsociados)
			.catch((error) => {
				UiUtils.showProgress(false);
				UiUtils.showError(error);
			});

		ApiClient.getCentroDeudorInstitutos()
			.then(this.onFinishGetListInstitutos)
			.catch((error) => {
				UiUtils.showProgress(false);
				UiUtils.showError(error);
			});

		this.updateSearchButtonTitle(this.state.searchButtonDisabled);
	}

	onFinishGetListAsociados = (res) => {
		UiUtils.showProgress(false);

		let listAsociados = [
			{
				value: 0,
				desc: "Seleccione Asociado",
			},
		];
		listAsociados = listAsociados.concat(
			res.map((item) => {
				return {
					value: item.numero,
					desc: item.nombre + ` (${item.numero})`,
				};
			})
		);

		let asociadoUnico = listAsociados.length == 2;
		this.setState({
			listAsociados: listAsociados,
			asociado: asociadoUnico ? listAsociados[1].value : 0,
			searchButtonDisabled: !asociadoUnico,
		});

		this.updateSearchButtonTitle(!asociadoUnico);
	};

	onFinishGetListInstitutos = (res) => {
		UiUtils.showProgress(false);

		let listInstitutos = [
			{
				value: 0,
				desc: "Seleccione Instituto",
			},
		];
		listInstitutos = listInstitutos.concat(
			res.map((item) => {
				return {
					value: item.numero,
					desc: item.nombre + ` (${item.numero})`,
				};
			})
		);

		this.setState({
			listInstitutos: listInstitutos,
			instituto: listInstitutos.length == 2 ? listInstitutos[1].value : 0,
		});
	};

	onInstitutoChange = (ev) => {
		// Recupero los asociados relacionados con el Instituto seleccionado
		ApiClient.getCentroDeudorAsociados(ev.value)
			.then(this.onFinishGetListAsociados)
			.catch((error) => {
				UiUtils.showProgress(false);
				UiUtils.showError(error);
			});

		this.state.asociado = 0;

		let disabled = true;

		this.setState({
			instituto: ev.value,
			searchButtonDisabled: disabled,
		});

		this.updateSearchButtonTitle(disabled);
	};

	onAsociadoChange = (ev) => {
		let disabled = ev.value == 0 || this.state.instituto == 0;

		this.setState({
			asociado: ev.value,
			searchButtonDisabled: disabled,
		});

		this.updateSearchButtonTitle(disabled);

		// TODO: actualizar lista de institutos en base al asociado seleccionado
	};

	updateSearchButtonTitle = (disabled) => {
		let title =
			"Realiza la búsqueda de deudores para el Instituto y Asociado seleccionados";
		if (disabled) {
			title =
				"Debe seleccionar un Instituto y un Asociado para realizar la búsqueda";
		}

		this.setState({
			searchButtonTitle: title,
		});
	};

	onBuscarClick = () => {
		UiUtils.showProgress(true);

		ApiClient.getCentroDeudorAtrasosVigentes(
			this.state.asociado,
			this.state.instituto
		)
			.then((res) => {
				UiUtils.showProgress(false);

				if (Array.isArray(res)) {
					this.setState({
						resultado: res,
						asociadoBusqueda: this.state.asociado,
						institutoBusqueda: this.state.instituto,
					});
				} else {
					throw UiUtils.handledError("Error al realizar la búsqueda");
				}
			})
			.catch((error) => {
				UiUtils.showProgress(false);
				UiUtils.showError(error);
			});
	};

	onPDF = () => {
		UiUtils.showProgress(true);

		ApiClient.centroDeudorExportListado(
			this.state.asociadoBusqueda,
			this.state.institutoBusqueda
		).then(
			(data) => {
				UiUtils.showProgress(false);

				let archivo = data.file;
				let nombre = data.filename
					? data.filename
					: "Atrasos Vigentes.pdf";

				const linkSource = `data:application/pdf;base64,${archivo}`;
				const downloadLink = document.createElement("a");

				// https://medium.com/octopus-labs-london/downloading-a-base-64-pdf-from-an-api-request-in-javascript-6b4c603515eb
				downloadLink.href = linkSource;
				downloadLink.download = nombre;
				downloadLink.click();
			},
			(reason) => {
				UiUtils.showProgress(false);
				UiUtils.showError(reason);
			}
		);
	};

	render() {
		const titulo = (
			<h4>
				<i className="fa fa-filter"></i>
				Filtros de búsqueda
			</h4>
		);

		return (
			<div>
				<h1>Atrasos Vigentes</h1>

				<Panel defaultExpanded header={titulo}>
					<Row>
						<Col md={4}>
							<InputSelect
								value={this.state.instituto}
								label={lstrings.instituto}
								options={this.state.listInstitutos}
								onChange={this.onInstitutoChange}
							/>
						</Col>
						<Col md={4}>
							<InputSelect
								value={this.state.asociado}
								label={lstrings.asociado}
								options={this.state.listAsociados}
								onChange={this.onAsociadoChange}
							/>
						</Col>
					</Row>

					<Row>
						<Col sm={4} smOffset={4}>
							<Button
								bsStyle="primary"
								className="btn-block"
								title={this.state.searchButtonTitle}
								disabled={this.state.searchButtonDisabled}
								onClick={this.onBuscarClick}
							>
								{lstrings.buscar}
							</Button>
						</Col>
					</Row>
				</Panel>

				{this.state.resultado && (
					<div className="container-fluid">
						<div
							className="pull-right"
							style={{
								marginTop: "20px",
								marginRight: "20px",
								marginBottom: "20px",
							}}
						>
							<Button onClick={this.onPDF}>
								Descargar PDF{" "}
								<b>
									<i className="fa fa-file-pdf-o"></i>
								</b>
							</Button>
						</div>

						<TableAsociados data={this.state.resultado} />
					</div>
				)}
			</div>
		);
	}
}

TabAsociados.propTypes = {
	match: PropTypes.object,
};

export default TabAsociados;



// WEBPACK FOOTER //
// ./src/scenes/asociados/TabAsociados.js